<template>
  <div class="invoice-wrap">
    <div class="success"
      v-if="success === true">
      <div class="iconfont">&#xe666;</div>
      <div class="success-text">提交成功！<span>( <span>{{counter}}</span>秒后跳转详情页 )</span></div>
      <div class="success-desc">我们会尽快开具发票，感谢您的支持</div>
    </div>
    <template v-if="success === false">
      <div class="order-info">
        <div class="order-info-item">
          <span>订单编号:</span>
          <span>{{preOrderNum}}</span>
        </div>
        <div class="order-info-item">
          <span>订单金额:</span>
          <span>{{actualPrice}}元</span>
        </div>
      </div>
      <div class="invoice-info">
        <div class="tabbar">
          <div :class="{'active': tabIndex === 0}"
            @click="tabIndex=0;">增值税普票</div>
          <div :class="{'active': tabIndex === 1}"
            @click="tabIndex=1;">增值税专票</div>
        </div>
        <div class="tab-content">
          <template v-if="tabIndex === 0">
            <div class="invoice-info-item">
              <div class="invoice-info-name">发票抬头:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="公司全称"
                  v-model="corpName"
                  maxlength="45">
                <div class="input-clear iconfont"
                  v-if="corpName"
                  @click="corpName='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">税号:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="税号"
                  v-model="taxId"
                  maxlength="20">
                <div class="input-clear iconfont"
                  v-if="taxId"
                  @click="taxId='';">&#xe684;</div>
              </div>
            </div>
            <div class="gray-block"></div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">收件人:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="姓名"
                  v-model="name"
                  maxlength="20">
                <div class="input-clear iconfont"
                  v-if="name"
                  @click="name='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">手机号:</div>
              <div class="invoice-info-input">
                <input type="tel"
                  placeholder="手机号"
                  v-model="mobile"
                  maxlength="11">
                <div class="input-clear iconfont"
                  v-if="mobile"
                  @click="mobile='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">收件邮箱:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="邮箱"
                  v-model="email">
                <div class="input-clear iconfont"
                  v-if="email"
                  @click="email='';">&#xe684;</div>
              </div>
            </div>
          </template>
          <template v-if="tabIndex === 1">
            <div class="invoice-info-item">
              <div class="invoice-info-name">发票抬头:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="公司全称"
                  v-model="corpName"
                  maxlength="45">
                <div class="input-clear iconfont"
                  v-if="corpName"
                  @click="corpName='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">税号:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="税号"
                  v-model="taxId"
                  maxlength="20">
                <div class="input-clear iconfont"
                  v-if="taxId"
                  @click="taxId='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">单位地址:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="单位地址"
                  v-model="bankAddress"
                  maxlength="40">
                <div class="input-clear iconfont"
                  v-if="bankAddress"
                  @click="bankAddress='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">电话号码:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="电话号码"
                  v-model="phone"
                  maxlength="19">
                <div class="input-clear iconfont"
                  v-if="phone"
                  @click="phone='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">开户银行:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="开户银行"
                  v-model="bankName"
                  maxlength="37">
                <div class="input-clear iconfont"
                  v-if="bankName"
                  @click="bankName='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">银行账户:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="银行账户"
                  v-model="bankAccount"
                  maxlength="25">
                <div class="input-clear iconfont"
                  v-if="bankAccount"
                  @click="bankAccount='';">&#xe684;</div>
              </div>
            </div>
            <div class="gray-block"></div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">收件人:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="姓名"
                  v-model="name"
                  maxlength="20">
                <div class="input-clear iconfont"
                  v-if="name"
                  @click="name='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">手机号:</div>
              <div class="invoice-info-input">
                <input type="tel"
                  placeholder="手机号"
                  v-model="mobile"
                  maxlength="11">
                <div class="input-clear iconfont"
                  v-if="mobile"
                  @click="mobile='';">&#xe684;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">收件地址:</div>
              <div class="invoice-info-input"
                @click="cityPickerVisible=true;">
                <div class="input"
                  v-if="applyCityAddress">
                  <p>{{applyCityAddress}}</p>
                </div>
                <input type="tel"
                  placeholder="选择省/市"
                  disabled
                  v-else>
                <div class="iconfont arrow">&#xe678;</div>
              </div>
            </div>
            <div class="invoice-info-item">
              <div class="invoice-info-name">详细地址:</div>
              <div class="invoice-info-input">
                <input type="text"
                  placeholder="请输入详细地址信息"
                  v-model="addressDetail"
                  maxlength="200">
                <div class="input-clear iconfont"
                  v-if="addressDetail"
                  @click="addressDetail='';">&#xe684;</div>
              </div>
            </div>
          </template>
        </div>
        <div class="confirm-btn button"
          @click="submit"
          :class="{'unclickable': !allOk}">保存提交</div>
        <div class="tip">
          <span class="iconfont">&#xe665;</span>普票（电子发票3个工作日），专票（纸质发票7-10个工作日）
        </div>
      </div>
      <div class="mask"
        v-show="cityPickerVisible"
        @click="cityPickerVisible=false;"
        @touchmove.prevent>
        <div class="city-picker">
          <van-picker :show-toolbar="true"
            visible-item-count="5"
            confirm-button-text="确定"
            :columns="cityList"
            value-key="name"
            @confirm="cityPickerConfirm" />
        </div>
      </div>
    </template>
    <div class="corp-list"
      v-if="corpList.length > 0 && corpName && corpSelected === false">
      <div class="corp-item"
        v-for="item of corpList"
        :key="item.name"
        @click.stop="corpSelect(item)">
        {{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
import cityList from '../../public/city.js';
export default {
  name: 'invoice',
  data() {
    return {
      corpList: [], // 筛选企业
      cityList, // 省市区列表
      customerNo: '', // 企业id
      actualPrice: '', // 订单金额
      orderNum: '', // 订单编号
      tabIndex: 0, // 选中的tabIndex
      corpName: '', // 公司全称
      taxId: '', // 税号
      name: '', // 姓名
      mobile: '', // 手机号
      email: '', // 邮箱
      bankAddress: '', // 开户地址
      phone: '', // 电话号码
      bankName: '', // 开户银行
      bankAccount: '', // 银行账户
      province: '', // 省
      city: '', // 市
      county: '', // 区
      addressDetail: '', // 详细住址
      applyCityAddress: '', // 省市区
      cityPickerVisible: false,
      success: '',
      corpSelected: false,
      counter: 3,
      preOrderNum:''
    };
  },
  watch: {
    success(val) {
      if (val) {
        let timer = setInterval(() => {
          this.counter--;
          if (this.counter === 0) {
            clearInterval(timer);
            this.$router.replace({
              path: '/invoice-detail',
              query: this.$route.query,
            });
          }
        }, 1000);
      }
    },
    corpName(val) {
      if (this.corpSelected === false) {
        if (val) {
          this._fetch('/gw/salarypcapi/wx/salary/outInvoice/searchCreditCodeByName', {
            word: val,
            orderNum:this.orderNum
          }).then((res) => {
            if (res.success) {
              if (Array.isArray(res.data.dataList)) {
                this.corpList = res.data.dataList;
              }
            }
          });
        } else {
          this.corpList = [];
        }
      }
      this.corpSelected = false;
    },
  },
  computed: {
    // eslint-disable-next-line
    allOk() {
      if (this.tabIndex === 0) {
        return this.corpName && this.taxId && this.name && this.mobile && this.email;
      } else if (this.tabIndex === 1) {
        return this.corpName && this.taxId && this.bankAddress && this.phone && this.bankName && this.bankAccount && this.name && this.mobile && this.applyCityAddress && this.addressDetail;
      }
    },
  },
  created() {
    document.title = '填写开票信息';
    this.orderNum = this.$route.query.orderNum;
    this.customerNo = this.$route.query.customerNo;
    this.preOrderNum = this.$route.query.preOrderNum;
    if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      location.href = `${location.origin}/invoice?customerNo=${this.customerNo}&orderNum=${this.orderNum}&preOrderNum=${this.preOrderNum}`;
    }
    this._fetch('/gw/salarypcapi/wx/salary/outInvoice/checkCorpOrder', {
      customerNo: this.customerNo,
      orderNum: this.orderNum,
      preOrderNum:this.preOrderNum
    }).then((res) => {
      if (res.success) {
        this.actualPrice = String(res.data.salaryBillOrder.actualPrice);
        if (res.data.salaryBillOrder.invoiceState === 0) {
          this.success = false;
        } else {
          // this.success = true;
          this.$router.replace({
            path: '/invoice-detail',
            query: this.$route.query,
          });
        }
      }
    });
  },
   mounted() {},
  methods: {
    corpSelect(item) {
      this.corpName = item.name;
      this.taxId = item.creditCode;
      this.corpList = [];
      this.corpSelected = true;
    },
    cityPickerConfirm(item) {
      this.applyCityAddress = item.join('/');
    },
    submit() {
      if (!this.allOk) {
        return false;
      } else {
        if (!/^1\d{10}$/.test(this.mobile)) {
          this._notification('请输入正确的手机号');
          return false;
        }
        if (this.tabIndex === 0 && !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.email)) {
          this._notification('请输入正确的邮箱');
          return false;
        }
        this._fetch('/gw/salarypcapi/wx/salary/outInvoice/applyInvoice', {
          orderNum: this.orderNum,
          preOrderNum:this.preOrderNum,
          invoiceType: this.tabIndex,
          corpName: this.corpName,
          licenseNumber: this.taxId,
          applyName: this.name,
          applyMobile: this.mobile,
          applyEmail: this.email,
          corpAddress: this.bankAddress,
          corpTel: this.phone,
          bankName: this.bankName,
          bankNum: this.bankAccount,
          applyCityAddress: this.applyCityAddress,
          applyDetailAddress: this.addressDetail,
        }).then((res) => {
          if (res.success) {
            this.success = true;
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '../assets/css/mixins.styl'
.invoice-wrap
  overflow-x hidden
  .order-info
    height 220px
    background #3975C6
    padding 24px 36px 0
    box-sizing border-box
    &-item
      line-height 80px
      font-size 28px
      display flex
      align-items center
      justify-content space-between
      color #fff
  .invoice-info
    overflow-x hidden
    margin-top -20px
    border-radius 16px 16px 0px 0px
    background #fff
    .tabbar
      height 100px
      display flex
      font-size 32px
      border-bottom 1px solid #E5E5E5
      box-sizing border-box
      &>div
        flex 1
        display flex
        align-items center
        justify-content center
      .active
        color #0082EF
        position relative
        &:after
          content ''
          width 100%
          height 4px
          absolute bottom 0 left 0
          background #0082EF
    .invoice-info-item + .invoice-info-item
      border-top 1px solid #E5E5E5
    .invoice-info-item:last-child
      border-bottom 1px solid #E5E5E5
    .invoice-info-item
      height 100px
      margin-left 36px
      box-sizing border-box
      padding-right 36px
      display flex
      align-items center
      justify-content space-between
      font-size 32px
      color #111
      .invoice-info-name
        width 226px
      .invoice-info-input
        display flex
        align-items center
        flex 1
        height 100%
        .iconfont
          color #BFBFBF
          font-size 32px
          margin-right -22px
          border 10px solid transparent
        .arrow
          font-size 16px
          color #888
          border 0
          margin-left 16px
          margin-right 0
        input, .input
          width 100%
          height 100%
          font-size 32px
          border 0
          color #111
          text-align right
          outline 0
          background #fff
        .input
          display flex
          align-items center
          justify-content flex-end
          p
            line-clamp()
    .gray-block
      height 24px
      background #F5F5F5
    .confirm-btn
      width 686px
      margin 80px auto 0
      &.unclickable
        opacity 0.5
        pointer-events none
    .tip
      margin 32px 32px 32px
      line-height 40px
      display flex
      align-items flex-start /* justify-content space-between */
      color #9EA0A3
      font-size 28px
      span
        color #1890FF
        font-size 32px
        margin-right 12px
  .city-picker
    position fixed
    bottom 0
    left 0
    right 0
    box-shadow 0px -1px 0px 0px rgba(230, 230, 230, 1)
  .success
    overflow-x hidden
    .iconfont
      font-size 180px
      color #49CB15
      margin 294px auto 0
      text-align center
    &-text
      line-height 60px
      color #111
      font-size 44px
      margin-top 40px
      text-align center
      display flex
      align-items center
      justify-content center
      span
        font-size 28px
        color #323232
        span
          color #10a9ff
    &-desc
      line-height 38px
      color #555
      font-size 28px
      margin-top 16px
      text-align center
  .corp-list
    background #fff
    absolute left 0 top 402px right 0
    height 12rem
    border-bottom 1px solid #e5e5e5
    overflow auto
    .corp-item
      padding-right 62px
      text-align right
      font-size 32px
      color #888
      height 88px
      box-sizing border-box
      border-bottom 1px solid #e5e5e5
      margin-left 36px
      position relative
      line-height 88px
      ellipse()
      &:after
        content ''
        width 24px
        height @width
        absolute right 24px top 50%
        transform translateY(-50%)
        background url('../assets/imgs/invoice-corp-item.png') 0 0 no-repeat
        background-size 100% 100%
</style>
